import { WebShopRootProvider } from "@/src/providers";
import { NextLayoutProps } from "@/src/shared/models/components";
import { Source_Sans_3 } from "next/font/google";
import { CookiesPanel } from "../../../CookiesPanel";
import GTMScript from "@/src/components/Scripts/GTMScript";
import { GoogleAnalytics } from "@next/third-parties/google";
const inter = Source_Sans_3({
    weight: ["400", "600", "700"],
    style: "normal",
    subsets: ["cyrillic"],
    display: "swap",
});

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export const AppRootLayout = ({ children }: NextLayoutProps) => {
    return (
        <html lang={"uk"} className={inter.className}>
        <head>
            {!!GTM_ID && <GTMScript id={GTM_ID} />}
        </head>
        <WebShopRootProvider>
            <body id={"root"}>
            {!!GTM_ID && (
                <noscript>
                    <iframe
                        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
                        height="0"
                        width="0"
                        style={{ display: "none", visibility: "hidden" }}
                    ></iframe>
                </noscript>
            )}
            {!!GA_MEASUREMENT_ID && <GoogleAnalytics gaId={GA_MEASUREMENT_ID} />}

            {children}
            <CookiesPanel />
            </body>
        </WebShopRootProvider>
        </html>
    );
};
